import { z } from 'zod';
import { DeviceKind } from '../shared/device-kind.js';
export const ANALYTICS_ERROR_CODES = {
    Unauthenticated: 'ANALYTICS_UNAUTHENTICATED',
    Forbidden: 'ANALYTICS_FORBIDDEN',
    Invalid: 'ANALYTICS_INVALID',
    FeatureDisabled: 'ANALYTICS_FEATURE_DISABLED',
};
export const AnalyticsDeviceKind = DeviceKind;
export const AnalyticsRange = z.enum(['24h', '7d', '30d', '90d']);
export const AnalyticsPageviewBeacon = z.object({
    path: z.string().min(1).max(2048),
    referrer: z.string().max(2048).optional().nullable(),
    deviceKind: AnalyticsDeviceKind.optional(),
    countryCode: z.string().regex(/^[A-Z]{2}$/).optional().nullable(),
});
export const AnalyticsScrollBeacon = z.object({
    path: z.string().min(1).max(2048),
    scrollDepthPct: z.number().int().min(0).max(100),
});
export const AnalyticsFunnelBeacon = z.object({
    funnelId: z.string().uuid(),
    step: z.string().min(1).max(120),
});
export const AnalyticsFunnel = z.object({
    id: z.string().uuid(),
    name: z.string(),
    steps: z.array(z.string()),
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
});
export const ProfileHomepageAnalyticsDailyPoint = z.object({
    day: z.string(),
    pv: z.number().int().min(0),
    uv: z.number().int().min(0),
});
export const ProfileHomepageAnalyticsDeviceBreakdown = z.object({
    deviceKind: AnalyticsDeviceKind,
    pv: z.number().int().min(0),
});
export const ProfileHomepageAnalyticsResponse = z.object({
    range: AnalyticsRange,
    path: z.string(),
    pv: z.number().int().min(0),
    uv: z.number().int().min(0),
    maxScrollDepthPct: z.number().int().min(0).max(100).nullable(),
    deviceBreakdown: z.array(ProfileHomepageAnalyticsDeviceBreakdown),
    daily: z.array(ProfileHomepageAnalyticsDailyPoint),
    updatedAt: z.string().datetime({ offset: true }),
});
//# sourceMappingURL=analytics.js.map